import { useNavigate } from "react-router-dom";
import {
    ArrowRightIcon,
    CheckIcon,
    SparklesIcon,
} from "@heroicons/react/24/outline";

import dubaiSkyline from "../assests/images/dubai-skyline.webp";

export default function FinalCTA() {
    const navigate = useNavigate();

    return (
        <section className="w-full bg-white py-12 sm:py-14 lg:py-16">
            <div className="mx-auto  max-w-[1536px]
              px-4
            sm:px-6
            lg:px-8">

                <div
                    className="
                        group
                        relative
                        overflow-hidden
                        rounded-3xl
                        bg-[#062F4F]
                        shadow-[0_15px_50px_rgba(6,47,79,0.16)]
                    "
                >

                    {/* Background Image */}
                    <img
                        src={dubaiSkyline}
                        alt="Dubai skyline"
                        className="
                            absolute
                            inset-0
                            h-full
                            w-full
                            object-cover
                            opacity-25
                            transition-transform
                            duration-1000
                            group-hover:scale-105
                        "
                    />

                    {/* Dark Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-r from-[#062F4F] via-[#062F4F]/95 to-[#062F4F]/65" />

                    {/* Decorative Circle */}
                    <div
                        className="
                            pointer-events-none
                            absolute
                            -right-28
                            -top-28
                            h-72
                            w-72
                            rounded-full
                            border-[45px]
                            border-[#F7B928]/10
                        "
                    />

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -bottom-32
                            right-[20%]
                            h-64
                            w-64
                            rounded-full
                            border-[35px]
                            border-white/[0.04]
                        "
                    />

                    {/* Content */}
                    <div
                        className="
                            relative
                            z-10
                            grid
                            items-center
                            gap-8
                            px-6
                            py-10
                            sm:px-10
                            sm:py-12
                            lg:grid-cols-[1fr_auto]
                            lg:px-14
                            lg:py-14
                        "
                    >

                        {/* =========================
                            LEFT CONTENT
                        ========================== */}
                        <div className="max-w-2xl">

                            {/* Eyebrow */}
                            <div className="mb-4 flex items-center gap-2.5">

                                <span
                                    className="
                                        flex
                                        h-8
                                        w-8
                                        items-center
                                        justify-center
                                        rounded-full
                                        bg-[#F7B928]
                                    "
                                >
                                    <SparklesIcon className="h-4 w-4 text-[#062F4F]" />
                                </span>

                                <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#F7B928]">
                                    Your Dubai Adventure Starts Here
                                </span>

                            </div>


                            {/* Heading */}
                            <h2
                                className="
                                    text-3xl
                                    font-extrabold
                                    leading-tight
                                    tracking-tight
                                    !text-white
                                    sm:text-4xl
                                    lg:text-5xl
                                "
                            >
                                Ready to Find Your
                                <span className="block text-[#F7B928]">
                                    Perfect Dubai Stay?
                                </span>
                            </h2>


                            {/* Description */}
                            <p
                                className="
                                    mt-4
                                    max-w-xl
                                    text-sm
                                    leading-7
                                    text-white/70
                                    sm:text-base
                                "
                            >
                                Compare hotels, discover exclusive local deals,
                                and book your next Dubai stay with confidence.
                                Your perfect hotel is closer than you think.
                            </p>


                            {/* Trust Points */}
                            <div className="mt-6 flex flex-wrap gap-x-5 gap-y-3">

                                <div className="flex items-center gap-2 text-xs font-medium text-white/80">
                                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0B6E8E]">
                                        <CheckIcon className="h-3 w-3 text-white" />
                                    </span>
                                    Verified Hotels
                                </div>

                                <div className="flex items-center gap-2 text-xs font-medium text-white/80">
                                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0B6E8E]">
                                        <CheckIcon className="h-3 w-3 text-white" />
                                    </span>
                                    Best Local Rates
                                </div>

                                <div className="flex items-center gap-2 text-xs font-medium text-white/80">
                                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0B6E8E]">
                                        <CheckIcon className="h-3 w-3 text-white" />
                                    </span>
                                    Secure Booking
                                </div>

                            </div>

                        </div>


                        {/* =========================
                            RIGHT CTA
                        ========================== */}
                        <div className="lg:min-w-[230px]">

                            <button
                                type="button"
                                onClick={() => navigate("/hotels")}
                                className="
                                    group/button
                                    flex
                                    w-full
                                    items-center
                                    justify-center
                                    gap-3
                                    rounded-2xl
                                    bg-[#FF5A1F]
                                    px-7
                                    py-4
                                    text-sm
                                    font-extrabold
                                    text-white
                                    shadow-[0_10px_30px_rgba(255,90,31,0.28)]
                                    transition-all
                                    duration-300
                                    hover:bg-[#e94d16]
                                    hover:shadow-[0_15px_35px_rgba(255,90,31,0.38)]
                                    active:scale-[0.98]
                                    sm:w-auto
                                    lg:w-full
                                "
                            >
                                <span>Find My Hotel</span>

                                <ArrowRightIcon
                                    className="
                                        h-5
                                        w-5
                                        transition-transform
                                        duration-300
                                        group-hover/button:translate-x-1
                                    "
                                />
                            </button>

                            <p className="mt-3 text-center text-[11px] text-white/40">
                                Explore Dubai hotels & exclusive deals
                            </p>

                        </div>

                    </div>

                </div>

            </div>
        </section>
    );
}